import { createSlice } from "@reduxjs/toolkit";
import VwGnlMesajDTO from "src/models/Mesaj/VwGnlMesajDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IMesaj {
    open: boolean;
    muracaatId: number;
    editMode: boolean;
    activeRow: VwGnlMesajDTO;

    modulOpen: boolean;
    modulActiveRow: VwGnlMesajDTO;
    modulListeFetching: boolean;
};

export const MesajSlice = createSlice<IMesaj, MapReducerPayloads<IMesaj, {
    setOpen: boolean;
    setMuracaatId: number;
    setEditMode: boolean;
    setActiveRow: VwGnlMesajDTO;

    setModulOpen: boolean;
    setModulActiveRow: VwGnlMesajDTO;
    setModulListeFetching: boolean;
}>>({
    name: "mesaj",
    initialState: {
        open: false,
        muracaatId: 0,
        editMode: false,
        activeRow: new VwGnlMesajDTO(),

        modulOpen: false,
        modulActiveRow: new VwGnlMesajDTO(),
        modulListeFetching: true,
    },
    reducers: {
        /**
         * Mesaj ikonunu tıklanıldığında set edilir. Dialog penceresinin açılıp kapanması kontrol edilir.
         * @param state 
         * @param action 
        */
        setOpen: (state, action) => {
            state.open = action.payload
        },
        /**
         * Müracaat Id'sinin tutulduğu state. Dialog açıldığında müracaat bazlı kaydı getirmek için kullanılıyor. 
         * @param state 
         * @param action 
        */
        setMuracaatId: (state, action) => {
            state.muracaatId = action.payload
        },
        /**
         * Dialog penceresinde düzenleme ve kayıt eklemek için kullanılan state
         * @param state 
         * @param action 
        */
        setEditMode: (state, action) => {
            state.editMode = action.payload
        },
        /**
         * Mesajın düzenlenme ve eklenmesinde kullanılan state
         * @param state 
         * @param action 
        */
        setActiveRow: (state, action) => {
            state.activeRow = action.payload
        },
        /**
         * Modül penceresinde okunacak mesajın dialog penceresi için kullanılan state
         * @param state 
         * @param action 
        */
        setModulOpen: (state, action) => {
            state.modulOpen = action.payload
        },
        /**
         * Modül için mesajın düzenlenme ve eklenmesinde kullanılan state
         * @param state 
         * @param action 
        */
        setModulActiveRow: (state, action) => {
            state.modulActiveRow = action.payload
        },
        /**
         * Modül listesi rtk api ile kullanılmadığı için state ile manipüle ederek veri çekiliyor.
         * Mesaj listesinin yenilenmesi için kullanılan state
         * @param state 
         * @param action 
        */
        setModulListeFetching: (state, action) => {
            state.modulListeFetching = action.payload
        }
    }
});